import { render, staticRenderFns } from "./RupturasDepartamento.vue?vue&type=template&id=3d822bff&scoped=true"
import script from "./RupturasDepartamento.vue?vue&type=script&lang=js"
export * from "./RupturasDepartamento.vue?vue&type=script&lang=js"
import style0 from "./RupturasDepartamento.vue?vue&type=style&index=0&id=3d822bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d822bff",
  null
  
)

export default component.exports